/**
 * Onboarding magic-link landing route (CLA-449 shell, CLA-450 Welcome) —
 * eagerly registers the file route; the landing/Welcome component and its
 * atom/RPC imports are deferred to `start.$token.lazy.tsx` so they load only
 * with this route, never in the always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/onboarding/start/$token")({});
